export const environment = {
  production: false,
  API_ENDPOINT: 'https://login.trackserver.co.uk/api/api/',
  ONE_SIGNAL_APP_ID: '84350ba3-eaf2-47be-8925-783a7370a752',
};
